/**
 * `/waitlist/confirmed` — success state after the waitlist form submits.
 *
 * If no router state is present (user typed the URL directly), redirects
 * back to `/waitlist`.
 */

import { Navigate, useLocation, Link } from 'react-router-dom';
import type { WaitlistApplyResponse } from '@eloquor/api-contract';
import { AuthShell } from '../components/layout/AuthShell';

interface NavState {
  result?: WaitlistApplyResponse;
}

export function WaitlistConfirmedPage() {
  const location = useLocation();
  const state = location.state as NavState | null;
  if (!state?.result) return <Navigate to="/waitlist" replace />;
  return (
    <AuthShell topRight={<Link to="/sign-in">Sign in</Link>}>
      <div className="auth-card">
        <div className="success-mark" aria-hidden>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 12.5l5 5 11-11"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="auth-eyebrow">
          <span className="num">02</span> · Confirmed
        </div>
        <h1 className="auth-title">
          You're on the <em>list.</em>
        </h1>
        <p className="auth-sub">
          We'll email an invite when a seat opens. No follow-ups until then — you can check your status any time from the sign-in page.
        </p>
      </div>
    </AuthShell>
  );
}
